import { isFirefox } from 'utils/browser';

export const getVoiceURI = (voice: SpeechSynthesisVoice) => {
  if (isFirefox()) {
    return voice.name;
  }
  return voice.voiceURI;
};
